var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.modalTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.error
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" },
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.error.ErrorCode.substring(
                                  0,
                                  _vm.error.ErrorCode.indexOf(".")
                                )
                              ) + "."
                            ),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.error.Error) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      attrs: { id: "notification-editor-form" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.onFormSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.enabled,
                                    expression: "enabled",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.enabled)
                                    ? _vm._i(_vm.enabled, null) > -1
                                    : _vm.enabled,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.enabled = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.enabled = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.enabled = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                " Active\n                                    "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Name (2 - 100 characters):")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.name,
                                  expression: "name",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                required: "",
                                minlength: "2",
                                maxlength: "100",
                              },
                              domProps: { value: _vm.name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.name = $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Description (optional):")]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.description,
                                  expression: "description",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { rows: "6" },
                              domProps: { value: _vm.description },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.description = $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _vm._v("Send when status is changed to:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.statusId,
                                    expression: "statusId",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.statusId = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              _vm._l(_vm.statuses, function (s) {
                                return _c(
                                  "option",
                                  { domProps: { value: s.Id } },
                                  [_vm._v(_vm._s(s.Name))]
                                )
                              }),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _vm._v("Send when previous status was:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.prevStatusId,
                                    expression: "prevStatusId",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.prevStatusId = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v("Any"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.statuses, function (s) {
                                  return _c(
                                    "option",
                                    { domProps: { value: s.Id } },
                                    [_vm._v(_vm._s(s.Name))]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Email subject:")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.emailSubject,
                                  expression: "emailSubject",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                required: "",
                                minlength: "2",
                                maxlength: "500",
                              },
                              domProps: { value: _vm.emailSubject },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.emailSubject = $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Reply to email:")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.emailReplyToEmail,
                                  expression: "emailReplyToEmail",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "email", required: "" },
                              domProps: { value: _vm.emailReplyToEmail },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.emailReplyToEmail =
                                    $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Recipients:")]),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                "Email recipients could be provided in two ways: from attribute and/or list of ad hoc emails separated by comma."
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.emailRecipientAttributeId,
                                    expression: "emailRecipientAttributeId",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.emailRecipientAttributeId = $event
                                      .target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v("Select attribute..."),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.attributes, function (attr) {
                                  return _c(
                                    "option",
                                    { domProps: { value: attr.Id } },
                                    [_vm._v(_vm._s(attr.Name))]
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.emailAdHocRecipients,
                                  expression: "emailAdHocRecipients",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder:
                                  "Add hoc emails separated by comma",
                              },
                              domProps: { value: _vm.emailAdHocRecipients },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.emailAdHocRecipients =
                                    $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Message:")]),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                "Message that will be send to the recipients."
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pull-right" }, [
                              _c("div", { staticClass: "dropdown" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-secondary dropdown-toggle",
                                    attrs: { "data-toggle": "dropdown" },
                                  },
                                  [_vm._v("Insert")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-menu",
                                    staticStyle: {
                                      height: "50vh",
                                      "min-width": "300px",
                                      "min-height": "300px",
                                      "overflow-y": "auto",
                                    },
                                  },
                                  _vm._l(_vm.emailSnippets, function (es) {
                                    return _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.insertEmailSnippet(
                                              es.Content
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(es.Title))]
                                    )
                                  }),
                                  0
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.emailMessage,
                                  expression: "emailMessage",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { rows: "6", required: "" },
                              domProps: { value: _vm.emailMessage },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.emailMessage = $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        form: "notification-editor-form",
                      },
                    },
                    [_vm._v(_vm._s(_vm.confirmButtonLabel))]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }